/* R34 row 12: best-seller swap and Add button for "Frequently bought with" (sections/ka-bought-with.liquid). */
(function () {
  var roots = document.querySelectorAll('[data-ka-bw]');
  if (!roots.length) return;

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: cur }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function bestSeller(handle) {
    return fetch('/collections/' + encodeURIComponent(handle) + '?sort_by=best-selling', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var scope = doc.querySelector('main') || doc;
        var seen = [];
        scope.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
          if (m && seen.indexOf(m[1]) === -1) seen.push(m[1]);
        });
        seen = seen.slice(0, 6);
        var i = 0;
        function next() {
          if (i >= seen.length) return Promise.reject();
          var h = seen[i++];
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : next(); }).then(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0];
            return v ? { p: p, v: v } : next();
          });
        }
        return next();
      });
  }

  function fill(li, hit) {
    var p = hit.p, v = hit.v;
    var img = li.querySelector('[data-bw-img]');
    var src = p.featured_image;
    if (img && src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2'); }
    li.querySelectorAll('[data-bw-link], [data-bw-name]').forEach(function (a) { a.setAttribute('href', p.url); });
    var n = li.querySelector('[data-bw-name]'); if (n) n.textContent = p.title;
    var pr = li.querySelector('[data-bw-price]'); if (pr) pr.textContent = money(v.price);
    var b = li.querySelector('[data-bw-add]'); if (b) b.setAttribute('data-variant-id', v.id);
  }

  roots.forEach(function (root) {
    root.querySelectorAll('li[data-bw-collection]').forEach(function (li) {
      var hasFallback = !!li.querySelector('[data-bw-add]');
      bestSeller(li.getAttribute('data-bw-collection')).then(function (hit) {
        if (!hasFallback) {
          li.hidden = true; return; /* server had nothing to clone; section keeps this slot hidden */
        }
        fill(li, hit);
      }).catch(function () { /* keep the server-rendered first available product */ }).then(function () {
        li.classList.remove('is-pending');
        li.setAttribute('data-bw-ready', '1');
      });
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bw-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!id) return;
      var label = btn.getAttribute('data-label') || btn.textContent.trim();
      btn.setAttribute('data-label', label);
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          btn.textContent = 'Added ✓';
          /* Same hand-off as ka-rifle-breakdown: the theme's cart drawer and bubble listen for cart:update. */
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'ka-bought-with', data: { itemCount: cart.item_count, source: 'ka-bought-with', variantId: id } }
          }));
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        })
        .catch(function () {
          btn.textContent = 'Try again';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        });
    });
  });
})();
